
import { computed, defineComponent, Ref, resolveComponent, h } from 'vue';
import siteContextStore from '@/shared/content/site-context.store';
import { QueryKeys } from '@/shared/config/route-query.config';

export default defineComponent({
    name: 'PDPLink',
    props: {
        sku: {
            required: true,
            type: String,
        },
        title: {
            required: false,
            type: String,
            default: '',
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        editGuid: {
            required: false,
            type: String,
            default: '',
        },
        configurationGuid: {
            required: false,
            type: String,
            default: '',
        },
    },
    setup(props, { attrs, slots }) {
        const editGuid: Ref<string | undefined> = computed(() => {
            return props.editGuid ? `${QueryKeys.Edit}=${props.editGuid}` : '';
        });

        const configurationGuid: Ref<string | undefined> = computed(() => {
            return props.configurationGuid ? `${QueryKeys.PDPConfigurationId}=${props.configurationGuid}` : '';
        });

        const queryString: Ref<string | undefined> = computed(() => {
            const queryStringArray: Array<string> = [];

            if (editGuid.value) queryStringArray.push(editGuid.value);
            if (configurationGuid.value) queryStringArray.push(configurationGuid.value);

            return queryStringArray.length === 0
                ? undefined
                : queryStringArray.join('&');
        });

        const url: Ref<string | undefined> = computed(() => {
            if (props.disabled) {
                return undefined;
            }

            return queryString.value
                ? `${siteContextStore.settings.productDetailPageLink.url}${props.sku}/?${queryString.value}`
                : `${siteContextStore.settings.productDetailPageLink.url}${props.sku}/`;
        });

        const component = resolveComponent('RouterLinkConditional');

        return () => h(component, {
            ...attrs,
            ...props,
            to: url.value,
            spaEnabled: siteContextStore.settings.productDetailPageLink.spaLink,
        }, slots);
    },
});
